// extracted by mini-css-extract-plugin
export default {"clarity":"#0b64eb","primary":"#0b64eb"};